export const ApiSettingsInvoicingDocuments = (axios, obuBaseUrl) => {
  axios.setBaseURL(obuBaseUrl)

  const save = async (id, payload) => {
    const result = await axios.post(`/api/settings/invoicing-documents/${id}`, payload)
    return result.data
  }

  const find = async (id) => {
    const result = await axios.get(`/api/settings/invoicing-documents/${id}`)
    return result.data
  }

  const load = async () => {
    const result = await axios.get('api/settings/invoicing-documents')
    return result.data
  }

  return {
    invoicingDocumentSettingsFind: find,
    invoicingDocumentSettingsLoad: load,
    invoicingDocumentSettingsSave: save
  }
}
